export const T = {
  // Backgrounds
  bg:       "#080b14",
  surface:  "#0d1020",
  card:     "#111527",
  cardHov:  "#141829",
  overlay:  "rgba(0,0,0,0.75)",

  // Borders
  border:   "#1a1e35",
  borderHov:"#2a2e50",

  // Text
  text:     "#dde1ff",
  textSub:  "#9299c4",
  muted:    "#454a6e",
  dim:      "#272b45",

  // Accents
  blue:     "#4f8ef7",
  blueD:    "#3a72e8",
  blueGlow: "rgba(79,142,247,0.25)",
  green:    "#00e676",
  red:      "#ff3d5a",
  orange:   "#ff6d2e",
  yellow:   "#ffb300",
  purple:   "#9c77f5",
  cyan:     "#00cfff",
  pink:     "#f062b0",

  // Fonts
  mono:     "'Fira Code', 'JetBrains Mono', 'Courier New', monospace",
  display:  "'Exo 2', 'Rajdhani', 'Orbitron', sans-serif",
};

export const SEV_COLOR = {
  critique: "#ff3d5a",
  haute:    "#ff6d2e",
  moyenne:  "#ffb300",
  faible:   "#00e676",
  info:     "#00cfff",
};

export const STATUS_CFG = {
  "validé":     { label: "Validé",     color: "#00e676", bg: "rgba(0,230,118,0.1)" },
  "en_attente": { label: "En attente", color: "#ffb300", bg: "rgba(255,179,0,0.1)" },
  "rejeté":     { label: "Rejeté",     color: "#ff3d5a", bg: "rgba(255,61,90,0.1)" },
  "duplicate":  { label: "Duplicate",  color: "#9c77f5", bg: "rgba(156,119,245,0.1)" },
};
